import { RefObject, useEffect } from 'react';
import { create } from 'zustand';

interface TableWidthState {
  fullWidth: number;
  setFullWidth: (width: number) => void;
}

export const useTableWidthStore = create<TableWidthState>((set) => ({
  fullWidth: 0,
  setFullWidth: (width: number) => set({ fullWidth: width }),
}));

export const useSetTableFullWidth = (
  columnWidthStorage: number[],
  firstRowRef: RefObject<HTMLDivElement>
) => {
  const setFullWidth = useTableWidthStore((state) => state.setFullWidth);

  useEffect(() => {
    if (firstRowRef.current) {
      const children = firstRowRef.current.children;
      const totalWidth = Array.from(children).reduce((acc, child) => {
        const childWidth = child.getBoundingClientRect().width;
        const columnWidth = columnWidthStorage[child.id];
        return acc + (columnWidth ?? childWidth);
      }, 0);
      setFullWidth(totalWidth);
    }
  }, [columnWidthStorage, setFullWidth]);

  return {
    firstRowRef,
  };
};
